import "signalr";
import { AddConversionModel } from "../types";
import ConversionService from "../services/ConversionService";
import StoreContainer from "./StoreContainer";

class ConversionStore {
  async addConversion({ conversionId, dollarAmount, customData }: any) {
    if (typeof conversionId !== "number") {
      throw new Error("Conversion Id is malformed");
    }

    if (dollarAmount && typeof dollarAmount !== "number") {
      throw new Error("Dollar amount is malformed");
    }

    var data: AddConversionModel = {
      ConversionID: conversionId,
      GroupID: StoreContainer.GroupStore.getActiveOrPageGroupId(),
      VisitorID: StoreContainer.VisitorStore.getVisitorId(),
      DollarAmount: dollarAmount,
      CustomData: JSON.stringify(customData)
    };

    await ConversionService.addConversion(
      StoreContainer.SettingStore.getSiteId(),
      data
    );
  }
}

export default ConversionStore;
